export const ru = {
  LANGUAGE: {
    RU: 'рус',
    EN: 'англ',
    JP: 'япон',
  },
  FORM_LANGUAGES: {
    RUSSIAN: 'Русский',
    ENGLISH: 'Английский',
    JAPAN: 'Японский',
  },
  BASE: {
    REQUIRED: 'Обязательное поле',
    CANCEL: 'Отмена',
    REGISTRATION: 'Регистрация',
    BACK: 'Назад',
    SUCCESS: 'Успешно',
    ERROR: 'Ошибка',
  },
  AUTHORIZATION: {
    TITLE: 'Авторизация',
    INPUT_LOGIN: 'Введите ваш логин',
    LOGIN: 'Логин',
    INPUT_PASSWORD: 'Введите ваш пароль',
    PASSWORD: 'Пароль',
    SIGN_IN: 'Войти',
    RESTORE_PASSWORD: 'Восстановить пароль',
  },
  RESTORE_PASSWORD: {
    TITLE: 'Восстановить пароль',
    INPUT_LOGIN: 'Введите ваш логи',
    LOGIN: 'Логин',
    RESET: 'Сбросить',
    SUCCESS: 'Письмо с инструкцией отправлено',
    SIGN_IN: 'Войти',
    USER_NOT_FOUND: 'Пользователь не найден',
  },
  CHANGE_PASSWORD: {
    TITLE: 'Сменить пароль',
    INPUT_NEW_PASSWORD: 'Введите новый пароль!',
    INPUT_PASSWORD: 'Введите пароль',
    REPEAT_PASSWORD: 'Повторите пароль',
    PASSWORD_NOT_MATCH: 'Пароли не совпадают',
    CHANGE: 'Изменить',
    SIGN_IN: 'Войти',
    CHANGED: 'Пароль изменен',
  },
  PROFILE: {
    MAIN_LINK: 'Главная',
    TITLE: 'Профиль',
    NAME: 'Имя',
    EMAIL: 'Почта',
    INCORRECT_EMAIL: 'Неправильный адрес',
    PHONE: 'Телефон',
    TELEGRAM: 'Телеграм',
    TELEGRAM_CONNECTED: 'Подключен',
    CONNECT: 'Привязать',
    USER_UPDATE: 'Изменить профиль',
    REQUIRED_FIELD: 'Обязательно поле',
    DEFAULT_LANGUAGE: 'Язык по умолчанию',
    UPDATE: 'Обновить',
    CHANGE_PASSWORD: 'Сменить пароль',
    OLD_PASSWORD: 'Старый пароль',
    NEW_PASSWORD: 'Новый пароль',
    CONFIRM_PASSWORD: 'Повторить пароль',
    CONFIRM: 'Вы уверены',
    LANGUAGE: 'Язык',
    CHANGE_PASSWORD_BTN: 'Изменить',
    CHANGE_LANG_RUS: 'Русский',
    CHANGE_LANG_ENG: 'Английский',
    CHANGE_LANG_JPN: 'Японский',
    CANCEL: 'Отмена',
  },
  MUTATION: {
    ERROR: 'Ошибка',
    SUCCESS: 'Успешно',
    PARTIAL: 'Частично',
  },
  LOGIN: {
    SEND_EMAIL: 'Ссылка на смену пароля отправлена на почту',
  },
  COUNTERPARTY_REGISTRATION: {
    FILL_FORM: 'Заполнить форму',
    ACCEPT_DOC: 'Создавая аккаунт, вы соглашаетесь с',
    SUCCESS_REGISTRATION: 'Регистрация завершена',
    COMPANY_NAME: 'Название компании',
    POSTAL_CODE: 'Почтовый индекс',
    COMPANY_REGISTRATION_DATE: 'Дата регистрации компании',
    COMPANY_REGISTRATION_NUMBER: 'Номер регистрации компании',
    COMPANY_INVOICE_NUMBER: 'Номер счета-фактуры компании',
    CONTACT_PERSON: 'Контактное лицо',
    PHONE: 'Телефон',
    FAX: 'Факс',
    EMAIL: 'Email',
    COMMENT: 'Комментарий',
    LANGUAGE: 'Язык',
    ACCEPT: 'Зарегистрировать аккаунт',
    BACK_TO_SITE: 'Вернуться на сайт',
    CUSTOMER: 'Покупатель',
    SUPPLIER: 'Поставщик',
    JAPAN_JURISDICTION: 'Японское право',
    INTERNATIONAL_JURISDICTION: 'Международное право',
    CHOOSE_COUNTRY: 'Выбрать страну',
    JAPAN_INDIVIDUAL_REGISTRATION: 'Физическое лицо',
    JAPAN_JURISTIC_PERSON_REGISTRATION: 'Юридическое лицо',
    INTERNATIONAL_INDIVIDUAL_REGISTRATION: 'Физическое лицо',
    INTERNATIONAL_JURISTIC_PERSON_REGISTRATION: 'Юридическое лицо',
    FULL_NAME: 'Полное имя',
    COMPANY_ADDRESS: 'Адрес компании',
    IMPORT_COMMODITY: 'Основной импортный товар',
    CARS: 'Автомобили',
    PARTS: 'Запчасти',
    COUNTERPARTY_TYPE: 'Выберите тип сотрудничества',
    COUNTERPARTY_SUPPLIER_FORM: 'Форма регистрации поставщика',
    COUNTERPARTY_CUSTOMER_COUNTRY: 'Выберите страну вашей юрисдикции',
    CHOOSE_ORGANIZATION_TYPE: 'Выберите тип организации',
    FILL_COMPANY_FORM: 'Заполните данные о вашей компании',
    FILL_INDIVIDUAL_FORM: 'Заполните ваши данные',
    REGISTERED_ADDRESS: 'Адрес регистрации',
    ALREADY_HAVE_AN_ACCOUNT: 'У вас уже есть аккаунт?',
    LOGIN: 'Войти',
    TERMS_OF_USE_AND_PRIVACY_POLICY: 'условиям пользования и политикой конфиденциальности',
    DELETE_NOTE:
      'Если вы хотите удалить аккаунт, пожалуйста, свяжитесь с нами по этому адресу электронной почты:',
    FULL_ADDRESS: 'Полный адрес',
    SAME_WITH_PHONE: 'Совпадает с телефоном',
    ENGINE: 'ДВС',
  },
  NOTIFICATIONS: {
    UNNAMED_NOTIFICATION: 'Неизвестное уведомление',
    ENABLED: 'Включено',
    DISABLED: 'Выключено',
    LOCKED: 'Заблокировано',
    NOTIFICATIONS: 'Уведомления',
    NO_NOTIFICATIONS: 'Уведомлений нет',
  },
  TRANSACTIONS: {
    TITLE: 'История транзакций',
    CREATED_AT: 'Дата',
    USER: 'Провёл',
    CHANGED_AMOUNT: 'Изменение баланса',
    CURRENCY_RATE: 'Курс валюты',
    MONEY_TYPE: 'Форма денег',
    TYPE: 'Тип транзакции',
    AMOUNT_DIRTY: 'Сумма в валюте транзакции',
    AMOUNT_CLEAR: 'Сумма в валюте баланса',
    AMOUNT: 'Сумма',
    RATE: 'Курс',
    CREATE_INCOME: 'Пополнить баланс',
    CREATE_TRANSFER: 'Перевести на другой баланс',
    BALANCE_TRANSFER: 'Перевод',
    BALANCE_INCOM: 'Пополнение',
    BOX_ISSUED: 'Выдано в подотчет',
    BOX_HANDED: 'Сдано в офис',
    BANK_HANDED: 'Сдано в банк',
    CURRENT_BALANCE: 'Текущий баланс',
    CURRENCY: 'Валюта',
    BALANCE_INFO: 'Информация о балансе',
    CURRENT_COUNT: 'Текущее количество',
    COUNT_CHANGE: 'Изменение количества',
    TAX_STICKER_INFO: 'Информация о налоговой наклейке',
    TAX_STICKER: 'Налоговая наклейка',
  },
  ACCOUNTABLE: {
    ACCOUNTABLE: 'Подотчет',
    NAME: 'Имя',
    ROLES: 'Роли',
    CASH_BALANCE: 'Баланс',
    ADD_TAX_STICKER: 'Выдать в подотчет',
    REMOVE_TAX_STICKER: 'Сдать в офис',
    TAX_STICKERS: 'Налоговые наклейки',
    TAX_STICKER: 'Налоговая наклейка',
    ADD_BANK: 'Сдать наличные в банк',
    ADD_OFFICE: 'Сдать наличные в офис',
    ADD_SELF: 'Выдача наличных в подотчет',
    AMOUNT: 'Сумма',
    VIEW_TRANSACTIONS: 'История транзакций',
    BALANCES: 'Балансы',
    CASH: 'Наличные',
    COUNT: 'Количество',
    ADD_EXPENSE: 'Списание на расходы',
    TRANSFER_CASH: 'Перевести на другой баланс',
    TO: 'Кому перевести',
    SELECT_USER: 'Выберите пользователя',
    COMMENT: 'Комментарий',
  },
  CHATS_CENTER: {
    TITLE: 'Чат-центр',
    CREATE_CHAT: 'Создать чат',
    CHAT_CREATION_FAILED: 'Не удалось создать чат',
    CHAT_CREATION_SUCCESSFULLY: 'Чат создан успешно',
    TOPIC: 'Тема чата',
    MESSAGE: 'Сообщение',
    FILES: 'Файлы',
    ADD_CHAT: 'Создать чат',
    SELECT_PARTICIPANTS: 'Выберите участников',
    PARTICIPANTS: 'Участники',
    CHAT_PARTICIPANTS_ADDED_SUCCESSFULLY: 'Участники добавлены успешно',
    CHAT_PARTICIPANTS_ADDED_FAILED: 'Ошибка при добавлении участников',
    NO_CHATS: 'Чаты не найдены',
    UNNAMED_CHAT: 'Без названия',
    NO_MESSAGES: 'Сообщений пока нет',
    EMPTY_MESSAGE: 'Пустое сообщение',
    YESTERDAY: 'Вчера',
    TWO_DAYS_AGO: 'Позавчера',
    CHAT: 'Чат',
    TYPE_MESSAGE: 'Написать сообщение...',
    SEND: 'Отправить',
    ATTACH_FILES: 'Прикрепить файлы',
    ADD_PARTICIPANTS: 'Добавить участников',
    REMOVE_PARTICIPANT: 'Удалить участника',
    MESSAGE_SEND_FAILED: 'Не удалось отправить сообщение',
    MESSAGES_LOAD_FAILED: 'Не удалось загрузить сообщения',
    MUTE: 'Выключить уведомления',
    UNMUTE: 'Включить уведомления',
  },
};
